import React, { useEffect, useState } from "react"
import { matchPath, Outlet, useLocation, useNavigate } from "react-router-dom"
import { HeaderNavContent, PageHeaderProvider } from "../../components/Header"
import SideBarContainer from "../SidebarContainer"
import { AdminRoutes as menuAdminRoutes } from "../../routes/index"
import { LoadingContainerScreen } from "../../components/Loading"
import { useDispatch, useSelector } from "react-redux"
import { Helmet } from "react-helmet"
import { platformDetails } from "../../core/utils/platformDetails"
import { isMobile } from "react-device-detect"
import Send from "../../core/communication"
import { useOnlineStatus } from "../../core/utils/hooks/useUsers"
import { setData } from "../../core/redux/app/Actions"
import { getPlatform } from "../../core/utils/platform"

function NewAdminContainer({ children, ...props }) {
  const dispatch = useDispatch()
  const currentUser = useSelector((state) => state.app.user)
  const rehydrated = useSelector((state) => state.app.rehydrated)
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = location
  const [collapsed, setCollapsed] = useState(true)
  const [hasHeader, setHasHeader] = useState(true)
  const isUsersPath = pathname === "/users"
  const isFarmerProfilePath = matchPath("/farmer/profile/:id", pathname)
  const chat = useSelector((state) => state.app.chat)
  const isOnline = useOnlineStatus()

  if (rehydrated && (!currentUser || !currentUser.access_token)) {
    // Preservar parâmetros da URL ao navegar para login
    const search = window.location.search
    navigate(`/authentication/login${search}`)
  }

  useEffect(() => {
    if (!isMobile) {
      setCollapsed(false)
    } else {
      dispatch(setData({ assistanceCategory: false }))
    }
  }, [])

  useEffect(() => {
    const { pathname, state } = location
    const page = menuAdminRoutes().filter((item) => item.path.includes(pathname.split("/")[1]))[0]
    const noHeader = state?.hiddenHeader || page?.hiddenHeader

    if (noHeader) {
      setHasHeader(false)
    } else {
      setHasHeader(true)
    }
  }, [location, isOnline])

  const { platformName } = platformDetails()
  const isChatOnly = getPlatform() === "4"
  
  return (
    <div className="app wrapper-app">
      <Helmet>
        <title>{platformName}</title>
      </Helmet>
      {currentUser?.access_token && (
        <>
          <SideBarContainer
            navigate={navigate}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            isChatOnly={isChatOnly}
            {...props}
          />

          <React.Suspense fallback={<LoadingContainerScreen />}>
            <div className={`content-wrapper ${isChatOnly ? "chat-only-wrapper" : collapsed ? "full-size" : ""}`}>
              <PageHeaderProvider>
                <div className="App">
                  {!isChatOnly && <HeaderNavContent />}
                  <main
                    className={`
                      ${
                        hasHeader && !isChatOnly
                          ? `content ${verificationPath(pathname) ? "active" : ""}`
                          : `content ${
                              chat && chat?.id
                                ? "content--notchatpadding"
                                : pathname === "/chat" || pathname === "/offline" || isChatOnly
                                ? "content--notpadding"
                                : "content--full"
                            }  ${verificationPath(pathname) ? "active" : ""}`
                      }
                      ${isUsersPath ? "users-content" : ""}
                      ${isFarmerProfilePath ? "farmer-profile-content" : ""}
                      ${!isOnline ? "app-offline" : ""}
                      ${isChatOnly ? "chat-only" : ""}
                    `}>
                    {children}
                    <Outlet context={collapsed} />
                  </main>
                </div>
              </PageHeaderProvider>
            </div>
          </React.Suspense>
        </>
      )}
    </div>
  )
}

export default NewAdminContainer

const verificationPath = (path) => {
  switch (path) {
    // case "/users":
    //   return true
    case "/planning":
      return true
    case "/appointments":
      return true
    case "/assistance-link":
      return true
    case "/reports":
      return true
    default:
      return false
  }
}
